import { Button, useDisclosure } from '@chakra-ui/react';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useToast,
} from '@chakra-ui/react';
import { useRef } from 'react';
import { deleteUser } from '../../../../services/adminService';

//need to create a lambda function for deletion
const DeleteUserButton = ({ clerkId, username, adminId }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = useRef();
  const toast = useToast();

  const handleDelete = async () => {
    try {
        const response = await deleteUser(clerkId, adminId);
        if(response.ok){
            toast({
                title: 'User deleted.',
                description: 'User delete successfully.',
                status: 'success',
                duration: 5000,
                isClosable: true,
            })
        } else{
            toast({
                title: 'error.',
                description: 'error while trying to delete user.',
                status: 'error',
                duration: 5000,
                isClosable: true,
            })
        }
    }catch (error){
        console.error('error while trying to delete user', error)
    }
    onClose();
  };

  return (
    <>
      <Button colorScheme="red" onClick={onOpen}>
        Delete
      </Button>

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirm Delete
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to delete <b>{username}</b>? This action cannot be undone.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={handleDelete} ml={3}>
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default DeleteUserButton;
